<div class="token-validation-page">
    <div class="content">
        <p>Validating your token, please wait...</p>

        <div class="btn-wrap">
            <button mat-button class="secondary" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
